import { io } from "socket.io-client";
import { baseURL } from "./config";

let socket = null;

// Get socket URL from baseURL (remove trailing slash and /api if present)
const getSocketUrl = () => {
  let socketUrl = baseURL;
  if (socketUrl.endsWith("/")) {
    socketUrl = socketUrl.slice(0, -1);
  }
  // Remove /api if present
  socketUrl = socketUrl.replace("/api", "");
  return socketUrl;
};

export const initSocket = (adminId) => {
  if (socket?.connected) {
    console.log("Socket already connected");
    return socket;
  }

  const socketUrl = getSocketUrl();
  console.log("Support chat socket connecting to:", socketUrl);

  socket = io(socketUrl, {
    transports: ["websocket"],
    query: { liveRoom: `liveRoom:admin:${adminId}` },
    autoConnect: true,
  });

  socket.on("connect", () => {
    console.log("Support chat socket connected, id:", socket.id);
    // Join admin support room
    socket.emit(
      "joinSupportChat",
      JSON.stringify({
        conversationId: "",
        participantId: adminId,
        participantType: "Admin",
      })
    );
  });

  socket.on("disconnect", (reason) => {
    console.log("Support chat socket disconnected:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("Support chat socket connection error:", error);
  });

  return socket;
};

export const getSocket = () => socket;

export const joinSupportChatRoom = (conversationId, adminId) => {
  if (socket?.connected) {
    socket.emit(
      "joinSupportChat",
      JSON.stringify({
        conversationId,
        participantId: adminId,
        participantType: "Admin",
      })
    );
    console.log("Joined support chat room:", conversationId);
  } else {
    console.warn("Socket not connected, cannot join room");
  }
};

export const leaveSupportChatRoom = (conversationId, adminId) => {
  if (socket?.connected) {
    socket.emit(
      "leaveSupportChat",
      JSON.stringify({
        conversationId,
        participantId: adminId,
        participantType: "Admin",
      })
    );
    console.log("Left support chat room:", conversationId);
  }
};

export const sendTypingIndicator = (conversationId, adminId, isTyping) => {
  if (socket?.connected) {
    socket.emit(
      "supportTyping",
      JSON.stringify({
        conversationId,
        participantId: adminId,
        participantType: "Admin",
        isTyping,
      })
    );
  }
};

export const markMessagesReadViaSocket = (conversationId, adminId) => {
  if (socket?.connected) {
    socket.emit(
      "markSupportMessagesRead",
      JSON.stringify({
        conversationId,
        readerId: adminId,
        readerType: "Admin",
      })
    );
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("Socket disconnected");
  }
};

export default socket;
